import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './Warehouse.styles';

interface WarehouseIconProps extends WithStyles<typeof styles> {
  color?: string;
  onClick?: () => void;
}

const WarehouseIconComponent: FC<WarehouseIconProps> = ({ classes, color, onClick }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      onClick={onClick}
      classes={{ root: classes.root }}
    >
      <path
        d="M2 18V6.63636L10 3L18 6.63636V18M10.8889 12.7059H5.55556V18H10.8889M10.8889 12.7059V18M10.8889 12.7059V9.17647H7.33333V12.7059H10.8889ZM10.8889 18H14.4444V10.9412H10.8889V18Z"
        stroke={color || '#7E8899'}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const WarehouseIcon = withStyles(styles)(WarehouseIconComponent);
